import { DateFormatService } from 'dmmp-services';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-item-content',
  templateUrl: './item-content.component.html'
})
export class ItemContentComponent implements OnInit {

  @Input() content
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() externalLink = new EventEmitter()
  medias = [
    { style: 'large', media: '(min-width:421px)' },
  ]

  constructor(private dateFormatService: DateFormatService) { }

  ngOnInit(): void {
    if (this.content?.length > 0) {
      switch (this.content[0]?.identifier) {
        case 'related_content_menu': {
          if (this.content[0]?.related_content?.length > 0) {
            switch (this.content[0]?.related_content[0].identifier) {
              case 'event': {
                if (!(this.content[0]?.related_content[0]?.date?.start instanceof Date)) {
                  this.content[0].related_content[0].date.start = this.dateFormatService.convertFromTimestampToDate(this.content[0].related_content[0].date?.start)
                }
                break;
              }
              case 'story': {
                if (!(this.content[0]?.related_content[0]?.created_at instanceof Date)) {
                  this.content[0].related_content[0].created_at = this.dateFormatService.convertFromTimestampToDate(this.content[0].related_content[0].created_at)
                }
                break;
              }
              case 'course': {
                this.content[0].related_content[0].callToActionText = 'Ver mas'
                break;
              }
            }
          }
          break
        }
      }
    }
  }

}
